import { Typography } from '@mui/material'
import { Environment, environmentToggle } from 'src/utils/feature-toggles'
import { sessionStorageItems } from '~constants/session-storage-items'
import { getEquivalentUrl } from '~utils/environment'
import { WarningRibbon } from './warning-ribbon'

export function StagePreviewRibbon() {
  const isStage = environmentToggle(Environment.Stage)

  // Check URL param first (cross-origin navigation), persist to sessionStorage
  const urlParams = new URLSearchParams(window.location.search)
  const urlPreviewMode = urlParams.get('stagePreview')
  if (urlPreviewMode === 'true') {
    sessionStorage.setItem(sessionStorageItems.stagePreviewMode, 'true')
    // Clean up URL param
    urlParams.delete('stagePreview')
    const newUrl = urlParams.toString()
      ? `${window.location.pathname}?${urlParams.toString()}${window.location.hash}`
      : `${window.location.pathname}${window.location.hash}`
    window.history.replaceState({}, '', newUrl)
  }

  const isPreviewMode = sessionStorage.getItem(
    sessionStorageItems.stagePreviewMode,
  )

  if (!isStage || !isPreviewMode) {
    return null
  }

  const handleGoToProduction = () => {
    sessionStorage.removeItem(sessionStorageItems.stagePreviewMode)
    window.location.href = getEquivalentUrl('production')
  }

  return (
    <WarningRibbon
      message={
        <>
          You are previewing the{' '}
          <Typography variant="paragraphBold1">staging environment</Typography>.
          Changes here will not affect production.
        </>
      }
      buttonLabel="Go to Production"
      onButtonClick={handleGoToProduction}
    />
  )
}
